import Swiper, {Navigation, Pagination} from 'swiper';

new Swiper('.destination__slider', {
    modules: [
        Navigation,
    ],
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
        nextEl: '.destination__slider__next',
        prevEl: '.destination__slider__prev',
    },
    breakpoints: {
        1024: {
            slidesPerView: 3.5,
        },
        767: {
            slidesPerView: 2.5,
        },
        480: {
            slidesPerView: 1.5,
        }
    }
})
;

new Swiper('.store-offers__slider', {
    modules: [
        Navigation,
    ],
    slidesPerView: 1,
    spaceBetween: 60,
    navigation: {
        nextEl: '.store-offers__slider__next',
        prevEl: '.store-offers__slider__prev',
    },
    breakpoints: {
        1024: {
            slidesPerView: 1.5,
            spaceBetween: 20,
        },
        767: {
            slidesPerView: 1.25,
            spaceBetween: 30,
        }
    }
});

new Swiper('.to-sell__slider', {
    modules: [
        Pagination
    ],
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    pagination: {
        el: '.to-sell__slider__pagination',
        type: 'bullets',
        clickable: true,
    },
    breakpoints: {
        1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
        767: {
            slidesPerView: 2,
            slidesPerGroup: 2,
        }
    }
});

